/**
 * EPN-104 — MOCK MODE ONLY. A tiny shared holder for "who is signed in" in the mock runtime, so other mock
 * gateways (Custom Pay Run, Payroll Review) can attribute actions to the real mock session user and apply
 * the same segregation-of-duties comparisons the real backend does (it reads the user from the validated
 * access token; no mock gateway has a token to decode).
 *
 * `MockIdentityGateway` is the ONLY writer: it sets the holder on a successful login and clears it on logout.
 * This file has no effect on real authentication — the real gateway (`HttpIdentityGateway`) never imports it,
 * and nothing here is ever consulted by product code outside mock gateways.
 *
 * `resetMockCurrentUserForTests()` is the explicit, test-only reset used between tests so one test's
 * session cannot leak into the next (see also `resetMockPayrollReviewStoreForTests()`).
 */
/** Stable mock user ids, defined once here so the mock identity gateway and the mock payroll-review fixtures
 * (which need "the admin's id" and "the approver's id" to model segregation-of-duties scenarios) can never
 * drift apart. Mock mode only. */
export const MOCK_ADMIN_USER_ID = '33333333-3333-3333-3333-333333333333';
export const MOCK_APPROVER_USER_ID = '88888888-8888-8888-8888-888888888801';

export interface MockCurrentUser {
  userId: string;
  email: string;
}

let current: MockCurrentUser | null = null;

export function setMockCurrentUser(user: MockCurrentUser): void {
  current = { ...user };
}

export function clearMockCurrentUser(): void {
  current = null;
}

export function getMockCurrentUser(): MockCurrentUser | null {
  return current ? { ...current } : null;
}

/** TEST-ONLY. */
export function resetMockCurrentUserForTests(): void {
  current = null;
}
